import React from "react";
import clsx from "clsx";
import { ConditionPreset } from "../../../../models/Entities";
import { Text } from "@merge-api/merge-javascript-shared";
import lowerCase from "lodash/lowerCase";
import moment from "moment";
import { operatorMap, PERIOD_OPTIONS_PLURAL_MAP } from "./constants";
import startCase from "lodash/startCase";
import { enumCaseToLowerCase } from "../../../../utils/casing";

const getPeriodDisplay = (value: string | number | undefined, period: string | undefined) => {
  if (!period || value === undefined) return period || "";
  const numValue = typeof value === "string" ? parseInt(value, 10) : value;
  return numValue === 1 && PERIOD_OPTIONS_PLURAL_MAP[period]
    ? PERIOD_OPTIONS_PLURAL_MAP[period]
    : period;
};

type ConditionPresetPublishChangesDialogItemProps = {
  className?: string;
  conditionPreset: Partial<ConditionPreset>;
  action: "added" | "deleted" | "changed";
};

const ConditionPresetPublishChangesDialogItem = ({
  className,
  conditionPreset,
  action,
}: ConditionPresetPublishChangesDialogItemProps) => {
  const { common_model, normalized_key_name, value, operator, is_end_user_configured, period } =
    conditionPreset;

  return (
    <div className={clsx("flex flex-row justify-between", className)}>
      <Text>
        <b>
          {startCase(common_model)} {lowerCase(normalized_key_name)}{" "}
        </b>
        {is_end_user_configured ? (
          <span className="text-gray-40">is user configurable</span>
        ) : value !== undefined && value !== null && period ? (
          <>
            {operator && lowerCase(operatorMap[operator].title)}{" "}
            <span className="ph-no-capture">{value}</span> {getPeriodDisplay(value, period)}
          </>
        ) : (
          <>
            {operator && lowerCase(operatorMap[operator]?.title)}{" "}
            <span className="ph-no-capture">
              {value !== undefined &&
              value !== null &&
              moment(String(value), moment.ISO_8601, true).isValid()
                ? moment(String(value)).format("M/D/YYYY")
                : enumCaseToLowerCase(String(value))}
            </span>
          </>
        )}
      </Text>
      <Text>
        {action === "added" && <span className="text-gray-40 ml-1.5">Added</span>}
        {action === "changed" && <span className="text-gray-40 ml-1.5">Changed</span>}
        {action === "deleted" && <span className="text-red-60 ml-1.5">Deleted</span>}
      </Text>
    </div>
  );
};

export default ConditionPresetPublishChangesDialogItem;
